export default __webpack_public_path__ + "static/media/front.5b922be1.png";